import { Image } from '@bfe/moly';
import { appPath } from '@web3/base-utils';
import { SingleDrawLotteryStatus } from '@/services/lottery';

type SingleRewardDisplayProps = {
  rewards: SingleDrawLotteryStatus[];
};

export const SingleRewardDisplay = ({ rewards }: SingleRewardDisplayProps) => {
  const { tokenIcon, rewardToken } = rewards[0];

  return (
    <div className="relative w-[360px] h-[280px] flex items-center justify-center">
      <Image
        src={`${appPath}/png/home/single-win-result.png`}
        alt="single win result"
        width={360}
        height={280}
      />
      <Image
        src={tokenIcon}
        alt={rewardToken}
        className="absolute w-[72px] h-[72px] translate-x-[40px] translate-y-[40px]"
      />
    </div>
  );
};
